import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=58d1ea4f&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=58d1ea4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d1ea4f",
  null
  
)

export default component.exports